<template>
	<div>
		<header class="header fixed-top">
			<nav>
				<div class="row">
					<div class="col-4"></div>
					<div class="col-4 px-0">
						<b-link class="logo mx-auto" style="float: none" href="/">
							<img src="/images/new_avatar_alfred_transp.png" alt="logo" />
						</b-link>
					</div>
					<div class="col-4 px-0"></div>
				</div>
			</nav>
		</header>
		<div class="wrapper row-offcanvas">
			<div v-if="isLoading">
				<b-container>
					<div class="text-center" style="top: 50px">
						<b-spinner label="Carregando"></b-spinner>
					</div>
				</b-container>
			</div>
			<div v-else>
				<b-container>
					<b-row class="mb-3" v-if="lastPrivacyPolicy">
						<b-col>
							<div v-html="lastPrivacyPolicy.body"></div>
						</b-col>
					</b-row>
				</b-container>
			</div>
		</div>

		<footer-section></footer-section>

		<footer-alter></footer-alter>

		<back-to-top visibleoffset="300">
			<b-button variant="secondary" size="lg" class="btn-to-top">
				<div style="font-size: 2rem">
					<b-icon icon="arrow-up"></b-icon>
				</div>
			</b-button>
		</back-to-top>
	</div>
</template>
<script>
	import ApiService from '../../../../common/api.service'
	import FooterSection from '../../landing/Elements/FooterSection'
	import FooterAlter from '../../landing/Elements/FooterAlter'
	import BackToTop from 'vue-backtotop'

	export default {
		name: 'privacy-policy',
		components: {
			FooterSection,
			FooterAlter,
			BackToTop
		},
		data() {
			return {
				isLoading: false,
				lastPrivacyPolicy: null
			}
		},
		created: async function () {
			window.addEventListener('scroll', this.handleScroll)
			this.getPublicPrivacyPolicyInitialData()
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		mounted: async function () {},
		filters: {},
		computed: {},

		watch: {},
		methods: {
			getPublicPrivacyPolicyInitialData: function () {
				this.isLoading = true
				ApiService.get('/legal/getPublicPrivacyPolicyInitialData')
					.then((response) => {
						this.lastPrivacyPolicy = response.data.lastPrivacyPolicy
					})
					.finally(() => {
						this.isLoading = false
					})
					.catch((error) => {})
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../landing/assets/css/style.css';
	@import '../../landing/assets/css/colors/red.css';
	.vue-back-to-top {
		bottom: 50px !important;
		right: 50px !important;
	}
	@media screen and (max-width: 767px) {
		.btn-to-top {
			width: 60px;
			height: 60px;
			padding: 0px 0px;
			border-radius: 50%;
			font-size: 22px;
			line-height: 22px;
		}
		.vue-back-to-top {
			bottom: 25px !important;
			right: 25px !important;
		}
	}

	@import '../../../layouts/css/customvariables';

	.header {
		z-index: 1030;

		nav {
			margin-bottom: 0;
			height: 50px;
			background: $header_color;
			background-size: 100% 100%;
			box-shadow: 0px 0px 10px #ccc;
		}

		.navbar-right {
			float: right;
			margin-right: 15px;
		}

		.logo {
			display: block;
			float: left;
			height: 50px;
			line-height: 41px;
			padding: 3px 10px;
			text-align: center;
			width: 250px;
			background: $header_color;

			img {
				width: 125px;
			}
		}

		.navbar-right {
			.dropdown-item {
				padding: 0;
				width: 100%;
				outline: none;
			}

			div.dropdown {
				> a {
					color: $zoom_color;
				}

				.dropdown-menu > button {
					padding: 10px 15px;
				}

				&.notifications-menu {
					height: 50px;

					.noti-icon {
						font-size: 18px;
					}
				}

				> a > i {
					font-size: 23px;
				}

				> a {
					display: block;
					padding: 12px;
				}

				&:hover > a {
					background-color: #ededed;
					color: #000;
				}

				> a.padding-user {
					padding-top: 8px;
					padding-bottom: 6px;
				}
			}
		}

		nav .sidebar-toggle {
			float: left;
			color: $toggle_color;
			font-size: 19px;
			padding-top: 10px;
		}
	}

	.noti_msg {
		font-size: 16px;
		padding: 10px;
		border: 1px solid #4f90c1;
		border-radius: 50px;
		margin-top: 10px;
	}

	.user.user-menu > button img {
		width: 35px;
		height: 35px;
	}

	/**** END HEADER RIGHT SIDE DROPDOWNS ****/

	@media screen and (max-width: 767px) {
		.dropdown.open .dropdown-menu {
			position: absolute;
		}
		.navbar-right > li > a {
			padding: 10px 12px;
		}
	}

	/* Fix menu positions on xs screens to appear correctly and fully */

	@media (max-width: 560px) {
		body .header .logo,
		body .header nav {
			width: 100%;
		}
		body .header nav .sidebar-toggle {
			padding-left: 15px;
		}
		// nav {
		//     height: 100px !important;
		// }
	}

	.notifications_badge_top {
		margin-top: -28px;
		margin-left: 10px;
		position: absolute;

		span {
			top: 1px;
			left: 2px;
			border-radius: 50%;
			font-size: 9px;
			padding: 0.23em 0.45em;
		}
	}

	.notifications-menu .dropdown-item {
		width: 100%;
		display: block;
	}

	.dropdown-footer {
		padding: 10px !important;
	}
</style>
<style type="text/css" lang="scss">
	@import '../../../layouts/css/customvariables';

	.wrapper {
		margin-top: 50px;
		// @media screen and (max-width: 560px) {
		//     margin-top: 100px;
		// }
	}

	.sidebar-toggle {
		margin-left: 10px;
	}

	.bell_bg {
		button.btn-secondary {
			background-color: $bell-color;
			border: none;
			border-radius: 0;
			box-shadow: none !important;

			&:hover {
				background-color: #ededed !important;
			}

			&:active {
				color: $toggle_color !important;
			}
		}

		//.btn-secondary:active
		&.show button {
			background-color: $bell-active !important;
		}

		&.user_btn .dropdown-toggle {
			padding: 7px 9px;
		}
	}

	.tabs_cont,
	.event_date {
		background-color: #fff !important;
	}

	body.left-hidden aside.right-aside {
		margin-left: 0;
	}

	body.left-hidden .header.fixed-top {
		padding-right: 0 !important;
	}

	// Notifications old alfred
	.bg-primary {
		background-color: #00b5b8 !important;
	}
	.bg-blue-grey {
		background-color: #607d8b !important;
	}
	.icon-bg-circle {
		color: #ffffff;
		padding: 0.5rem;
		border-radius: 50%;
	}

	// Ver melhor isso.. tem algo errado.
	#item_notification {
		padding: 0;
		width: 100%;
		outline: none;
	}
	#tab_notifications {
		max-height: 20rem;
		overflow-y: auto;
	}
	.fixedheader .dropdown-toggle::after {
		display: none;
	}
</style>
